"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var removeNotification_1 = require("../actions/removeNotification");
var notificationHandler_1 = require("../utils/notificationHandler");
var React = require("react");
var BaseToast = /** @class */ (function (_super) {
    tslib_1.__extends(BaseToast, _super);
    function BaseToast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onActionClick = function (e) {
            e.stopPropagation();
            notificationHandler_1.handleNotification(_this.props.notification);
        };
        _this.onCancelClick = function (e) {
            e.stopPropagation();
            removeNotification_1.default(_this.props.notification);
        };
        return _this;
    }
    return BaseToast;
}(React.Component));
exports.default = BaseToast;
//# sourceMappingURL=BaseToast.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/components/BaseToast.js
// module id = 642
// module chunks = 3 14 105 106 107